import {
  FETCH_PRICING_BY_STORE,
  FETCH_PRICING_BY_STORE_SUCCESS,
  FETCH_PRICING_BY_STORE_ERROR,
} from './types';
import { PRICING_BY_STORE_NUMBER } from '../../../universal/gql-operation-ids';
import { API_PROXY_V1 } from 'shared/app/utils/create-gql-fetcher';
import { selectedStoreSelector } from 'shared/app/state/selectors/ordering';
import { getShortStoreNumber } from 'shared/app/bundles/menu/util/get-filter-query';

export const flattenStorePrices = (pricesByZone = []) =>
  Array.isArray(pricesByZone)
    ? pricesByZone.flatMap((zone) => zone?.prices || [])
    : [];

export const fetchPricingByStore =
  () =>
  async (dispatch, getState, { gqlFetch }) => {
    const state = getState();
    const selectedStore = selectedStoreSelector(state);

    const {
      ownershipTypeCode,
      timeZone: storeTimeZone,
      storeNumber: longFormatStoreNumber,
    } = selectedStore?.store || {};

    const timeZone = storeTimeZone?.timeZoneId;
    const storeNumber = getShortStoreNumber(longFormatStoreNumber);

    if (!ownershipTypeCode || !timeZone || !storeNumber) {
      return;
    }

    const variables = {
      storeNumber,
      timeZone,
      ownershipTypeCode,
    };

    dispatch({ type: FETCH_PRICING_BY_STORE, payload: { storeNumber } });

    return gqlFetch({
      operationId: PRICING_BY_STORE_NUMBER,
      variables,
      destinationType: API_PROXY_V1,
    })
      .then((payload) => {
        const storePrices = flattenStorePrices(payload?.zonePrices);
        dispatch({
          type: FETCH_PRICING_BY_STORE_SUCCESS,
          payload: storePrices,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_PRICING_BY_STORE_ERROR, error });
      });
  };
